import { render, staticRenderFns } from "./NewImportation.vue?vue&type=template&id=64dca41e&"
import script from "./NewImportation.vue?vue&type=script&lang=js&"
export * from "./NewImportation.vue?vue&type=script&lang=js&"
import style0 from "./NewImportation.vue?vue&type=style&index=0&id=64dca41e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports